export default __webpack_public_path__ + "static/media/dapper.507f25c6.png";